import React, { useState } from 'react';
import { useContentPage } from '../context/ContentPageContext';
import ContentItem from './ContentItem';

const Column = ({ column, sectionId, canRemove }) => {
  const { addContent, updateContent, removeContent, moveContent, removeColumn } = useContentPage();
  const [showMenu, setShowMenu] = useState(false);

  const contentTypes = [
    { type: 'heading', icon: 'bi-type-h1', label: 'Heading' },
    { type: 'paragraph', icon: 'bi-paragraph', label: 'Paragraph' },
    { type: 'list', icon: 'bi-list-ul', label: 'List' },
    { type: 'image', icon: 'bi-image', label: 'Image' },
    { type: 'button', icon: 'bi-square', label: 'Button' },
  ];

  const handleAddContent = (type) => {
    addContent(sectionId, column.id, type);
    setShowMenu(false);
  };

  return (
    <div className="card h-100" style={{ minHeight: '200px', border: '2px dashed #e0e0e0' }}>
      <div className="card-header d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f8f9fa' }}>
        <h6 className="mb-0 text-muted">Column</h6>
        {canRemove && (
          <button
            className="btn btn-danger btn-xxs"
            onClick={() => removeColumn(sectionId, column.id)}
            title="Remove column"
            type="button"
          >
            <i className="bi bi-x"></i>
          </button>
        )}
      </div>
      <div className="card-body">
        {column.content.map((content, index) => (
          <ContentItem
            key={content.id}
            content={content}
            sectionId={sectionId}
            columnId={column.id}
            onUpdate={updateContent}
            onRemove={removeContent}
            onMove={moveContent}
            isFirst={index === 0}
            isLast={index === column.content.length - 1}
          />
        ))}

        <div className="dropdown">
          <button
            className="btn btn-outline-primary btn-sm w-100"
            onClick={() => setShowMenu(!showMenu)}
            type="button"
          >
            <i className="bi bi-plus-circle me-1"></i> Add Content
          </button>
          {showMenu && (
            <div className="dropdown-menu show w-100" style={{ position: 'relative', marginTop: '5px' }}>
              {contentTypes.map(({ type, icon, label }) => (
                <button
                  key={type}
                  className="dropdown-item"
                  onClick={() => handleAddContent(type)}
                  type="button"
                >
                  <i className={`bi ${icon} me-2`}></i>
                  {label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Column;
